import React from 'react'
import { backArrowSvg } from '../../../HomeLoans/svg';
import PhoneInput from 'react-phone-input-2';

const durationTypes = [
    { value: '0-30 (Days)', order: 1 },
    { value: '1-2 (Months)', order: 2 },
    { value: '2-6 (Months)', order: 3 },
    { value: 'More than 6 Months', order: 4 }
];

const StepTwo = ({
    setStep, 
    possessionDuration , 
    setPossessionDuration, 
    moveInDuration ,
    setMoveInDuration,
    mobile,
  onChange ,
  validator ,
  setIsTouched ,
  setInputFocused ,
  mobileHasError , 
  comment ,
  setComment ,
  isInputFocused,
  mobileNumberIsValid,
  onFormSubmit 
   
}) => {
    const isValidMoveInDuration = (moveInValue) => {
        if (!possessionDuration) return true;

        const possessionOrder = durationTypes.find(type => type.value === possessionDuration)?.order;
        const moveInOrder = durationTypes.find(type => type.value === moveInValue)?.order;
        
        return moveInOrder >= possessionOrder;
    };
       
  return (
    <div>
       <div className="flex text-base md:text-lg font-semibold justify-between py-3">
                <div
                    className="flex items-center gap-1 cursor-pointer"
                    onClick={() => setStep((prev) => prev - 1)}
                >
                   {backArrowSvg}

                    <button className="text-primary text-sm md:text-base">Back to Step 1</button>
                </div>

                <p className='text-sm md:text-base'>
                    Step <span className="text-primary text-base md:text-lg">2</span>
                    <span className=" text-xs md:text-sm">/2</span>
                </p>
            </div>
            <div className="flex flex-col gap-4">
            <div className="pt-3 flex  items-center">
                    <h2 className="font-semibold">
                        Possession Timeline
                    </h2>
                </div>

                <div className="flex flex-wrap justify-between items-center ">
                    {durationTypes.map((type) => (
                        <div
                            onClick={() => {
                               setPossessionDuration(type.value);
                               setMoveInDuration(null);
                            }}
                            className={`w-[45%] cursor-pointer border rounded-[10px] p-2 my-2 lg:whitespace-nowrap xl:whitespace-nowrap ${
                               possessionDuration === type.value ? 'bg-primary' : ''
                            }`}
                        >
                            <button
                                className={`${
                                    possessionDuration === type.value ? 'text-white' : ''
                                }`}
                            >
                                {type.value}
                            </button>
                        </div>
                    ))}
                </div>
                <div className="pt-3 flex  items-center">
                    <h2 className="font-semibold">
                        When are you planning to move-in ?
                    </h2>
                </div>

                <div className="flex flex-wrap justify-between items-center ">
                    {durationTypes.map((type) => (
                        <div
                        onClick={() => isValidMoveInDuration(type.value) && setMoveInDuration(type.value)}
                        disabled={!isValidMoveInDuration(type.value)}
                            className={`w-[45%] cursor-pointer border rounded-[10px] p-2 my-2  lg:whitespace-nowrap xl:whitespace-nowrap ${
                                moveInDuration === type.value ? 'bg-primary' : ''
                            }${!isValidMoveInDuration(type.value) ? 'opacity-50 cursor-not-allowed' : ''} `}
                        >
                            <button
                                className={`${
                                    moveInDuration === type.value ? 'text-white' : ''
                                }`}
                            >
                                {type.value}
                            </button>
                        </div>
                    ))}
                </div>

                <div className="mt-4">
                            <h1 className="text-left">Alternate Phone Number</h1>
                            <div className=" h-12 mt-2">
                                <PhoneInput
                                    country={'in'}
                                    countryCodeEditable={false}
                                    containerClass={`bg-white h-10 rounded outline-none border-none ${
                                        isInputFocused ? 'outline-none ' : ''
                                    }`}
                                    onlyCountries={[
                                        'in',
                                        'hk',
                                        'id',
                                        'kw',
                                        'my',
                                        'om',
                                        'qa',
                                        'sa',
                                        'sg',
                                        'ae',
                                        'gb',
                                        'eu',
                                        'us',
                                        'th'
                                    ]}
                                    containerStyle={{
                                        width: '100%',
                                        boxShadow: '0px',
                                        border: 'none',
                                        outline: 'none',
                                        borderRadius: 'none',
                                        marginTop: '-1.5px',
                                        height: '100%'
                                    }}
                                    inputStyle={{
                                        width: '100%',
                                        height: '100%',

                                        border: 'none',
                                        borderRadius: 'none',
                                        border: '2px solid #EBEAF2',
                                        backgroundColor: '#FFFFFF'
                                    }}
                                    buttonStyle={{
                                        backgroundColor: '#FFFFFF',
                                        border: 'none',
                                        border: '2px solid #EBEAF2'
                                    }}
                                    isValid={validator}
                                    onChange={onChange}
                                    value={mobile}
                                    enableSearch
                                    onBlur={() => {
                                        setIsTouched(true);
                                        setInputFocused(false);
                                    }}
                                    onFocus={() => setInputFocused(true)}
                                    inputClass=""
                                />
                                
                                {mobileHasError && (
                                    <div className="mb-6">
                                        <p className="text-left text-red-400 text-sm mt-1 ">
                                            {`Please enter a valid number`}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="mt-2">
                            <h2 className='text-left'>Any additional info?</h2>
                            <textarea
                                type="text"
                                className=" text-black w-full text-grey-900 h-16 lg:h-12 xl:h-16 rounded px-2 py-1 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px] placeholder-[#000000B3] mt-2"
                                
                                onChange={(e) => setComment(e.target.value)}
                                value={comment}
                            />
                        </div>
                        <button
                           
                           
                            className={`w-full text-white p-3 rounded-[10px] disabled:cursor-not-allowed disabled:bg-[#adadad] bg-primary`}
                            onClick={() => {
                                onFormSubmit();
                            }}
                            
                        >
                            Submit
                        </button>
                         

            </div>
    </div>
  )
}

export default StepTwo
